<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-row :gutter="10">
            <CommonExcel v-show="funcShow" ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
            <clear-cache-apply />
            <sync-data />
          </el-row>
        </div>

        <el-tabs tab-position="left" @tab-click="tabClick">
          <el-tab-pane label="开关配置">
            <el-form class="demo-form-inline">
              <el-form-item label="开 关" class="send_mail">
                <el-switch
                  v-model="formData.unlockTrailer"
                  style="display: block;margin-top: 7px;"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="开启"
                  inactive-text="关闭"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
              <el-form-item label="等级限制">
                <el-input v-model.number="formData.minLv" style="width: 150px;" placeholder="开始等级" />
                <span style="display:inline-block;padding: 0 5px;">-</span>
                <el-input v-model.number="formData.maxLv" style="width: 150px;" placeholder="结束等级" />
              </el-form-item>

              <el-button v-prevent-re-click size="mini" type="primary" @click="handleSaveOpen()">保存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="基础管理">
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="功能" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.function" multiple placeholder="请选择">
                    <el-option
                      v-for="item in funcArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="任务"
                width="180"
                align="center"
              >
                <el-table-column label="类型" align="center">
                  <template v-slot:default="{row}">
                    <el-select v-model="row.task.type" placeholder="请选择">
                      <el-option
                        v-for="item in taskArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="center">
                  <template v-slot:default="{row}">
                    <el-input v-model="row.task.num" :disabled="row.task.type == 1" placeholder="速度" />
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="多语言Key" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.langKey" placeholder="多语言Key" />
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template v-slot:default="scope">
                  <reward :value="scope.row.reward" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig(row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import {
  delRunFotItConf,
  importParkourCfg
} from '@/api/config/run-for-it-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import { getList, updateCfg, delFunc } from '@/api/config/function-preview-cfg'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'FunctionPreview',
  components: { SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      funcShow: false,
      curClass: 'functionTrailer',
      formData: { minLv: 0, maxLv: 0, unlockTrailer: 0 },
      funcArr: [
        { label: '自动投掷', value: 1 },
        { label: '野兽', value: 2 },
        { label: '每日签到', value: 3 },
        { label: '更高倍率', value: 4 },
        { label: '小猪银行', value: 5 },
        { label: '卡片收集', value: 6 },
        { label: '收集活动', value: 7 },
        { label: '每日任务', value: 8 },
        { label: '限时卡片', value: 9 },
        { label: '挖矿', value: 10 },
        { label: '锦标赛', value: 11 },
        { label: '团队', value: 12 }
      ],
      taskArr: [
        { label: '关卡', value: 0 },
        { label: '充值', value: 1 }
      ],
      loading: false,
      dialog: false,
      diaLogList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      type: 1,
      baseList: [{ task: {}, function: [], reward: [] }],
      mapDialog: false,
      mapDialogList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.initBase()
    },
    initBase() {
      getList(this.queryParams).then(res => {
        this.baseList = res.data
      })
      getCommonCfg({ name: this.curClass }).then(res => {
        this.formData = res.data
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      updateCfg({ data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
        this.initBase()
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      this.baseList = []
      for (let i = 0; i < excelData.length; i++) {
        const list = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { function: this.funcArr, task: this.taskArr }, true, 'label', 'value')
        for (const k in list) {
          const _val = list[k]
          _val.task = { type: _val.task[0].type, num: _val.task[0].num }
          this.baseList.push(_val)
        }
        this.msgSuccess('导入成功')
        break
      }
    },
    exportBaseCfg() {
      const name = ['功能预告配置']
      const hearer = []
      const excelData = []
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { function: this.funcArr, task: this.taskArr }, true, 'value', 'label')
      for (let i = 0; i < list.length; i++) {
        const tAk = this.$refs.CommonExcelRef.makeExcelData([list[i]], { function: { name: '功能', sub: [] }, task: { name: '任务配置', sub: { type: '任务', num: '数量' }}, reward: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}})
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      console.log('excelData', excelData)
      downloadExcelMultiSheet(this.$route.meta.title, name, hearer, excelData)
    },
    handleDel(index, id) {
      if (id === 0) {
        this.list[this.type].splice(index, 1)
      } else {
        delRunFotItConf({ id: id }).then(res => {
          this.list[this.type].splice(index, 1)
        })
      }
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, types: this.type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      importParkourCfg({ data: JSON.stringify(this.list[type]) }).then(res => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    addBaseConfig() {
      this.baseList.push({ task: {}, function: [], reward: [], id: 0 })
    },
    deleteBaseConfig(id) {
      this.$confirm('你确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delFunc({ id: id }).then(res => {
          this.msgSuccess('删除成功')
          this.initBase()
        })
      })
    },
    addMapDialogList() {
      this.mapDialogList.push({ type: 0, num: 1 })
    },
    deleteMapDialogList(index) {
      this.mapDialogList.splice(index, 1)
    },
    handleEditMapTask(config) {
      this.mapDialog = true
      this.mapDialogList = config
    },
    handleGetMapName(id) {
      for (let i = 0; i < this.taskArr.length; i++) {
        if (this.taskArr[i].value === id) {
          return this.taskArr[i].label
        }
      }
      return ''
    },
    handleMapTask(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        str += '任务：' + this.handleGetMapName(data[i].type) + '，数量：' + data[i].num + '\n'
      }
      return str
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleSaveOpen() {
      if (this.formData.minLv > this.formData.maxLv) {
        this.msgError('最小等级不能大于最大等级')
        return
      }
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.formData) }).then(res => {
        this.msgSuccess('保存成功')
        this.initBase()
      })
    },
    tabClick(val) {
      if (val.index === '1') {
        this.funcShow = true
      } else {
        this.funcShow = false
      }
    }
  }
}
</script>

